class Footer {
  constructor(element, options) {
    this._element = element
    this._options = { ...Footer.options, ...options }

    this._init()
  }

  static options = {}

  _state = {}

  _insertYear() {
    const currentDate = new Date()

    this._footerYear.innerHTML = currentDate.getFullYear()
  }

  _cacheSelectors() {
    this._footerYear = this._element.querySelector('[data-footer-year]')
  }

  _init() {
    this._cacheSelectors()
    this._insertYear()
  }
}

export default Footer
